import { useField, useFormikContext } from 'formik';
import { useMemo, ReactNode } from 'react';
import { SelectChangeEvent } from '@mui/material';

import { FormField } from '../FormField';
import { Select, SelectProps } from 'theSource/components/Select';

export interface SelectFieldProps extends Omit<SelectProps, 'error'> {
  helperText?: string;
  label: string;
  labelId: string;
  name: string;
  required?: boolean;
  testId?: string;
  value?: string;
  onChange?: (event: SelectChangeEvent, child?: ReactNode) => void;
}

export const SelectField = ({
  disabled,
  fullWidth = true,
  helperText,
  id,
  label,
  labelId,
  name,
  required,
  testId = 'select-field',
  ...props
}: SelectFieldProps) => {
  const [field, { error, touched }] = useField({
    name,
    type: 'select',
  });
  const { isSubmitting } = useFormikContext();

  const invalid = useMemo(() => touched && Boolean(error), [error, touched]);

  return (
    <FormField
      disabled={disabled || isSubmitting}
      error={invalid}
      fullWidth={fullWidth}
      helperText={invalid ? error : helperText}
      inputId={id}
      label={label}
      labelId={labelId}
      required={required}
      testId={testId}
    >
      <Select id={id} label={label} labelId={labelId} {...field} {...props} />
    </FormField>
  );
};
